module.exports = __webpack_public_path__ + "img/bl3fl02_center_001.db64425a.png";